<template>
    <!-- <div class="modal-body row background-color-login">
		<div class="col-md-6">
			<div class="login-logo">
				<a href="#">
				<img src="https://pub.automatad.com/static/img/apl-h.png">
				</a>
			</div>
			<div id="login" class="signin-card">
				<div id="form-login-username" class="form-group">
					<input class="form-control" v-validate="'required|email'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('email') }" name="email" type="text" placeholder="Email" v-model="credentials.email">
					<span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
					<span class="form-highlight"></span>
					<span class="form-bar"></span>
					<label for="username" class="float-label"></label>
				</div>
				<div id="form-login-password" class="form-group">
					<input class="form-control" v-validate="'required|min:6'" data-vv-delay="5000" :class="{'input': true, 'is-danger': errors.has('password') }" name="password" type="password" placeholder="Password" v-model="credentials.password">
					<span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
					<span class="form-highlight"></span>
					<span class="form-bar"></span>
					<label for="password" class="float-label"></label>
				</div>
				<div>
					<button class="btn btn-block btn-info ripple-effect" type="submit" @click="submit()" name="Submit" alt="sign in">Sign in</button>
				</div>
			</div>
		</div>
		<div class="col-md-6 backgroundImage">
		</div>
	</div> -->
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <div class="login100-pic js-tilt" data-tilt>
                    <img src="/static/img/Blue-Yeti.png" alt="IMG" />
                </div>
                <div class="login100-form validate-form">
                    <span class="login100-form-title">
                        <img
                            src="https://nivid.automatad.com/assets/img/logo-white-md.png"
                        />
                    </span>

                    <div
                        v-if="forgetPassword == false"
                        class="wrap-input100 validate-input"
                        data-validate="Valid email is required: ex@abc.xyz"
                    >
                        <input
                            class="input100"
                            v-validate="'required|email'"
                            data-vv-delay="1000"
                            :class="{
                                input: true,
                                'is-danger': errors.has('email'),
                            }"
                            name="email"
                            type="text"
                            placeholder="Email"
                            v-model="credentials.email"
                        />
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div
                        v-if="forgetPassword == false"
                        class="wrap-input100 validate-input"
                        data-validate="Password is required"
                    >
                        <input
                            class="input100"
                            v-validate="'required|min:6'"
                            data-vv-delay="5000"
                            :class="{
                                input: true,
                                'is-danger': errors.has('password'),
                            }"
                            name="password"
                            type="password"
                            placeholder="Password"
                            v-model="credentials.password"
                            v-on:keyup.enter="submit()"
                        />
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="fa fa-lock" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div v-if="forgetPassword == true">
                        <p>Enter your E-Mail ID</p>
                        <div
                            class="wrap-input100 validate-input"
                            data-validate="E-Mail is required"
                        >
                            <input
                                class="input100"
                                v-validate="'required|min:6'"
                                data-vv-delay="5000"
                                :class="{
                                    input: true,
                                    'is-danger': errors.has('email'),
                                }"
                                name="email"
                                type="email"
                                placeholder="E-Mail"
                                v-model="resetEmailID"
                                v-on:keyup.enter="resetPassword()"
                            />
                            <span class="focus-input100"></span>
                            <span class="symbol-input100">
                                <i class="fa fa-lock" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="back-login textAlign">
                            <button class="" type="submit" @click="backLogin()">
                                Back to Login
                            </button>
                        </div>
                        <div class="container-login100-form-btn">
                            <button
                                class="login100-form-btn"
                                type="submit"
                                @click="resetPassword()"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                    <div v-if="forgetPassword == false" class="textAlign">
                        <button
                            class=""
                            type="submit"
                            @click="forgetpassword()"
                        >
                            Forgot Password?
                        </button>
                    </div>
                    <div
                        v-if="forgetPassword == false"
                        class="container-login100-form-btn"
                    >
                        <button
                            class="login100-form-btn"
                            type="submit"
                            @click="submit()"
                            :disabled="!formValid"
                        >
                            Login
                        </button>
                    </div>

                    <!-- <div class="text-center p-t-12">
						<span class="txt1">
							Forgot
						</span>
						<a class="txt2" href="#">
							Username / Password?
						</a>
					</div> -->
                    <div class="text-center p-t-12"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);
import axios from "axios";
export default {
    data() {
        return {
            forgetPassword: false,
            credentials: {
                email: "",
                password: "",
            },
            roles: [],
            error: "",
            resetEmailID: "",
        };
    },
    created: function () {
        this.$nextTick(function () {
            if (this.$auth.check() == true) {
            }
        });
    },
    methods: {
        backLogin() {
            this.forgetPassword = false;
        },
        resetPassword() {
            this.$notify({
                title: "Success",
                message:
                    "If the account exists you will recieve an E-Mail for the password reset.",
                type: "success",
            });
            axios
                .post(BASE_URL + "v1/auth/password/reset/", {
                    email: this.resetEmailID,
                })
                .then(function (response) {
                    console.log("success");
                })
                .catch(function (err) {
                    console.log("error");
                });
        },
        forgetpassword() {
            this.forgetPassword = true;
        },
        submit() {
            var credentials = {
                email: this.credentials.email,
                password: this.credentials.password,
            };
            var redirect = this.$auth.redirect();
            console.log(redirect);
            this.$auth.login({
                data: credentials,
                url: BASE_URL + "v1/auth/login/",
                fetchUser: false,
                success: function (response) {
                    console.log(response);
                    if (
                        response.data.story_access &&
                        response.data.story_domain_id &&
                        response.data.story_pub_uuid
                    ) {
                        console.log("STORY ONLy");
                    }
                    this.roles = response.data.user.roles;
                    // if (this.$auth.ready()) {
                    // 	this.$auth.user(response.data.user)
                    // }
                    localStorage.setItem(
                        "user",
                        JSON.stringify(response.data.user)
                    );
                    this.$auth.user(JSON.parse(localStorage.getItem("user")));
                    this.$auth.watch.authenticated = true;
                    this.$auth.watch.loaded = true;
                    console.log(this.$auth.check(["admin"]));
                    console.log("Success");
                    console.error(this._user);
                },
                error: function () {
                    this.$notify({
                        title: "Warning",
                        message: "Unable to login, the credentials are wrong.",
                        type: "warning",
                    });
                },
                // this.$router.push('/admin/domains');

                redirect: { path: "/publisher/dashboard" },
            });
        },
    },
    computed: {
        formValid() {
            return this.credentials.email && this.credentials.password;
        },
        _user() {
            return this.$auth.user() || {};
        },
    },
};
</script>
<style scoped>
.extra-span {
    top: -38px;
}
.back-login {
    margin: 10px;
}
.textAlign {
    text-align: right;
}
</style>
<style>
#app {
    /*background: white !important;*/
    height: 100% !important;
}
.backgroundImage {
    /*background-image: url("http://keenthemes.com/metronic/preview/assets/app/media/img//bg/bg-4.jpg");*/
    background-attachment: fixed;
    background-size: cover;
    height: 800px;
}
.background-color-login {
    background-color: white;
    padding-top: 0px !important;
}
.login-logo {
    text-align: center;
    margin: 60px;
}
/* -- body styles ------------------------------------- */
/* -- button styles ------------------------------------- */
/*-- signin-card animation ---------------------------------------- */
.signin-card {
    -webkit-animation: cardEnter 0.75s ease-in-out 0.5s;
    animation: cardEnter 0.75s ease-in-out 0.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    opacity: 0;
}
/* -- login paper styles ------------------------------ */
.signin-card {
    max-width: 350px;
    border-radius: 2px;
    margin: 20px auto;
    padding: 20px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.signin-card .logo-image,
.signin-card h1,
.signin-card p {
    text-align: center;
}
/* -- font styles ------------------------------------- */
.display1 {
    font-size: 28px;
    font-weight: 100;
    line-height: 1.2;
    color: #757575;
    text-transform: inherit;
    letter-spacing: inherit;
}
.subhead {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.1;
    color: #212121;
    text-transform: inherit;
    letter-spacing: inherit;
}
/* card animation from Animate.css -------------------- */
@-webkit-keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        -ms-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
        -ms-transform: scale3d(1.1, 1.1, 1.1);
        transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
        -ms-transform: scale3d(0.9, 0.9, 0.9);
        transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        -ms-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
        -ms-transform: scale3d(0.97, 0.97, 0.97);
        transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        -ms-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}
@keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        -ms-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
        -ms-transform: scale3d(1.1, 1.1, 1.1);
        transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
        -ms-transform: scale3d(0.9, 0.9, 0.9);
        transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        -ms-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
        -ms-transform: scale3d(0.97, 0.97, 0.97);
        transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        -ms-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}
button[disabled="disabled"],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// Login.vue?55c8572d